import Modal from '../modal/Modal';
import OneClick from './OneClick';

const ModalForm = ({ prod, inStock, onHide, modal }) => {
  return (
    <>
      {inStock && (
        <Modal>
          <OneClick
            destroy={onHide}
            prod={prod}
            title="Купить в 1 клик"
            action="order_click"
            isOpen={modal}
          />
        </Modal>
      )}
      {!inStock && (
        <Modal>
          <OneClick
            destroy={onHide}
            prod={prod}
            title="Узнать цену"
            action="get_price"
            isOpen={modal}
          />
        </Modal>
      )}
    </>
  );
};

export default ModalForm;
